import React, { FC, useMemo } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import Select from 'react-select';

import { generateSelectStyles } from 'buyside/components/presentation/Fields/selectField';

import { labelize } from 'buyside/util/arrayHelper';

import fieldStyles from 'buyside/components/presentation/Fields/fieldStyles.scss';

const { catalystNames } = require('buyside/util/constantsFromRails.json');

const CatalystsField: FC<{ isDisabled?: boolean; name: string }> = ({ isDisabled, name }) => {
  const {
    field: { onBlur, onChange, ref, value },
    fieldState: { error },
    formState: { isSubmitting }
  } = useController({ name });

  const selectStyles = useMemo(
    () => generateSelectStyles({ error: Boolean(error), size: 'medium' }),
    [error]
  );

  return (
    <div className={classNames(fieldStyles.field, fieldStyles.medium)}>
      <label data-title>Catalysts</label>
      <Select
        classNamePrefix={name}
        isDisabled={isSubmitting || isDisabled}
        isMulti
        name={name}
        onBlur={onBlur}
        onChange={options => onChange(options.map(option => option.value))}
        options={labelize(catalystNames)}
        ref={ref}
        styles={selectStyles as any}
        value={labelize(value)}
      />
      {error?.message ? (
        <label data-error htmlFor={name}>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {error.message}
        </label>
      ) : null}
    </div>
  );
};

export default CatalystsField;
